import { render, staticRenderFns } from "./repair-create-upload.vue?vue&type=template&id=19620119"
import script from "./repair-create-upload.vue?vue&type=script&lang=js"
export * from "./repair-create-upload.vue?vue&type=script&lang=js"
import style0 from "./repair-create-upload.vue?vue&type=style&index=0&id=19620119&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports